export default __webpack_public_path__ + "static/media/ceraveFfCleanser.36d39050.jpg";